/**
 * DraftRestoredBanner — тонкая плашка «Черновик восстановлен · Очистить».
 * Показывается в шапке модала, когда подставлен сохранённый черновик.
 * Все строки — через i18n (common.draftRestored / common.draftClear).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DraftRestoredBanner({ onClear, posthog }) {
  const { t } = useTranslation();
  return (
    <div
      data-posthog={posthog ? `${posthog}_banner` : 'modal_draft_banner'}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
        padding: '7px 12px', marginBottom: 12,
        background: 'rgba(79,142,247,0.12)',
        border: '1px solid var(--accent, #6366f1)',
        borderRadius: 8, fontSize: 13, color: 'var(--accent, #6366f1)',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 500 }}>
        <span aria-hidden>↩</span>{t('common.draftRestored')}
      </span>
      <button
        type="button"
        onClick={onClear}
        data-posthog={posthog ? `${posthog}_clear` : 'modal_draft_clear'}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--accent, #6366f1)', fontSize: 13, fontWeight: 600,
          textDecoration: 'underline', padding: '0 2px', flexShrink: 0,
        }}
      >
        {t('common.draftClear')}
      </button>
    </div>
  );
}
